exports = module.exports = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step[data-v-850e3a1a]{color:#333;font-size:12px}.step .large[data-v-850e3a1a]{margin-left:5px;font-size:14px;font-weight:bold}.is-wait .step[data-v-850e3a1a]{color:#c0c4cc}[data-v-850e3a1a]:deep(.el-step__icon.is-icon){width:initial}", ""]);

// exports
